import React, { forwardRef, HTMLAttributes } from "react";
import { useCombinedThemeMode } from "../../../../util/theme/useCombinedThemeMode";
import { menuTheme } from "../../../menu/styled/menuTheme";
import { OptionBaseStyled, OptionBaseStyledProps } from "./OptionBaseStyled";

export interface OptionBaseProps extends Omit<OptionBaseStyledProps, "themeMode">, HTMLAttributes<HTMLDivElement> {}

export const OptionBase = forwardRef<HTMLDivElement, OptionBaseProps>((props, ref) => {
    const themeMode = useCombinedThemeMode();
    const optionHeight = props.height ?? menuTheme.optionHeight.normal(themeMode);
    return <OptionBaseStyled {...props} height={optionHeight} themeMode={themeMode} ref={ref} />;
});

OptionBase.displayName = "OptionBase";
